import {
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import React, { useState } from "react";

const { Panel } = Collapse;

const days = [];
for (let i = 1; i <= 28; i++) {
  days.push({ value: i });
}

function LateFeePolicy({ initialValues }) {
  const [lateFeeType, setLateFeeType] = useState("Percent");
  const [gracePeriod, setGracePeriod] = useState("after");
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [percentFrom, setPercentFrom] = useState(
    "Tenant's delinquent balance this month"
  );

  const handleChange = (e) => {
    console.log("*******")
    console.log(e)
    if (e.target.value > 0) {
      console.log("helllo ji")
      setDisabled(false);
    }
    if(e.target.value < 1){
      console.log("helllo ji******")

      setDisabled(true);
    }

  };

  console.log(disabled)

  const validatePercentage = (_, value) => {
    if (/^\d{1}\.\d{2}$/.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(
        'Invalid input format! Please enter a value in the format "0.00".'
      )
    );
  };
  const validateNumber = (_, value) => {
    if (isNaN(value) || value < 0) {
      return Promise.reject(
        new Error("Please enter a valid flat fee less than 100")
      );
    }
    return Promise.resolve();
  };
  return (
    <>
      <Form.Item label="Late Fee Type" name="lateFeeType">
        <Radio.Group
          name="radiogroup"
          value={lateFeeType}
          onChange={(e) => {
            setLateFeeType(e.target.value);
          }}
        >
          <Radio value="Flat">Flat</Radio>
          <Radio value="Percent">Percent</Radio>
        </Radio.Group>
      </Form.Item>
      {lateFeeType === "Flat" && (
        <Form.Item
          name="baseLateFeeFlat"
          label="Base Late Fee"
          rules={[
            {
              validator: validateNumber,
            },
          ]}
          initialValue={initialValues.baseLateFeeFlat}
        >
          <Input prefix="$" onChange={handleChange} />
        </Form.Item>
      )}
      {lateFeeType === "Percent" && (
        <Form.Item
          label="Base Late Fee"
          rules={[
            {
              validator: validatePercentage,
            },
          ]}
          name="baseLateFeePercent"
          initialValue={initialValues.baseLateFeePercent}
        >
          <Input suffix="%" onChange={handleChange} maxLength={4} />
        </Form.Item>
      )}
      <Form.Item label="Eligible Charges" name="eligibleCharges">
        <Select
          options={[
            { value: "Every Charge" },
            { value: "All Recurring Charges" },
            { value: "Only Recurring Rent" },
          ]}
        />
      </Form.Item>
      <Form.Item label="Grace Period" name="gracePeriod">
        <Radio.Group
          name="radiogroup"
          value={gracePeriod}
          onChange={(e) => {
            setGracePeriod(e.target.value);
          }}
        >
          <Row>
        <Col span={24}>
          <Row gutter={[4, 0]}>
            <Col span={3}>
              <Form.Item>
                <Radio value="after">After</Radio>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item name="gracePeriodAfterDays">
                <Input disabled={gracePeriod === "On day" ? true : false}/>
              </Form.Item>
            </Col>
            <Col span={2}>
              <Form.Item>Days</Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[4, 0]}>
            <Col span={4}>
              <Form.Item>
                <Radio value="On day">On day</Radio>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="gracePeriodOnDay">
                <Select options={days} disabled={gracePeriod === "after" ? true : false} style={{width: "100%"}} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>of following month</Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
        </Radio.Group>
      </Form.Item>
      <Collapse defaultActiveKey={["1"]} accordion>
        <Panel header="Optional Settings" key="1">
          <Form.Item
            label="Charge daily Late Fee"
            name="chargeDailyLateFee"
            valuePropName="checked"
          >
            <Checkbox
              checked={checked}
              onChange={() => setChecked(!checked)}
            ></Checkbox>
          </Form.Item>
          {checked && (
            <>
              <Form.Item
                name="dailyLateFee"
                label="Daily Late Fee"
              >
                <Input prefix="$" disabled={disabled} />
              </Form.Item>
              <Form.Item
                name="maxDailyLateFee"
                label="Max Daily Late Fee Amount"
              >
                <Input prefix="$" disabled={disabled} />
              </Form.Item>
            </>
          )}
          <Form.Item
            name="graceBalance"
            label="Grace Balance"
          >
            <Input prefix="$" />
          </Form.Item>
          {lateFeeType === "Percent" && (
            <>
              <Form.Item label="Calculate % From" name="percentFrom">
                <Radio.Group
                  name="radiogroup"
                  value={percentFrom}
                  onChange={(e) => {
                    setPercentFrom(e.target.value);
                  }}
                >
                  <Space direction="vertical">
                    <Radio value="Tenant's delinquent balance this month">
                      Tenant's delinquent balance this month
                    </Radio>
                    <Radio value="Tenant's entire delinquent balance, including previous months">
                      Tenant's entire delinquent balance, including previous
                      months
                    </Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label="Ignore Partial Payments"
                name="partialPayments"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
            </>
          )}
        </Panel>
      </Collapse>
    </>
  );
}

export default LateFeePolicy;
